import {Controller} from "stimulus"

export default class extends Controller {

    static targets = []

    initialize() {

        this.initScene()

    }

    animate($el) {

        $el.classList.add("is-in-view")

        const timer = setTimeout(() => {
            $el.classList.remove("is-in-view")
            $el.classList.add("has-been-animated")
            $el.classList.remove("will-be-in-view")
            clearTimeout(timer)
        }, this.duration)

    }

    initScene(){

        let $els

        if ( this.data.get("on-child") && parseInt(this.data.get("on-child")) ) {
            const childSelector = this.data.get("child-selector")
            if ( childSelector ) {
                $els = [...this.element.querySelectorAll(childSelector)]
            } else {
                $els = [...this.element.children]
            }
        } else {
            $els = [this.element]
        }

        const delay = this.delay

        $els.forEach($el => {

            if ( !$el.classList.contains("has-been-animated") ) {

                $el.classList.add("will-be-in-view")

                const io = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if ( entry.intersectionRatio > 0 ) {
                            if ( delay ) {
                                const timer = setTimeout(() => {
                                    this.animate($el)
                                    clearTimeout(timer)
                                }, delay)
                            } else {
                                this.animate($el)
                            }
                            io.disconnect()
                        }
                    })
                }, {
                    root: null,
                    margin: "0px",
                    threshold: [0, 1]
                })

                io.observe($el)

            }



        })

    }

    get duration(){
        const duration = this.data.get("duration")
        return duration ? parseInt(duration) : 1000
    }

    get delay(){
        const delay = this.data.get("delay")
        return delay ? parseInt(delay) : 0
    }

}